import React from 'react'

import { StyledJanus, StyledGridItem } from 'component-library/compositions/Janus/Janus.styled'
import { ThemeMargins } from 'component-library/__styling/settings/metrics'

export type JanusLayoutRatio = '1:1' | '3:1' | '1:3'

export interface Props {
    content: [React.ReactElement<any>, React.ReactElement<any>]
    hasBackgroundFill?: boolean
    verticalSpacing?: keyof ThemeMargins
    layoutRatio?: JanusLayoutRatio
}

export const Janus: React.FC<Props> = ({
    content,
    verticalSpacing,
    hasBackgroundFill,
    layoutRatio = '1:1',
}) => (
    <StyledJanus
        hasBackgroundFill={hasBackgroundFill}
        verticalSpacing={verticalSpacing}
        layoutRatio={layoutRatio}
    >
        <StyledGridItem layoutRatio={layoutRatio}>{content[0]}</StyledGridItem>
        <StyledGridItem layoutRatio={layoutRatio}>{content[1]}</StyledGridItem>
    </StyledJanus>
)
